/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Box } from '@chakra-ui/react';

export const Plate: React.FC<any> = ({ children, ...rest }) => (
  <Box
    background="white"
    w="100%"
    overflow="hidden"
    p={4}
    display="flex"
    alignItems="center"
    justifyContent="space-between"
    cursor="pointer"
    borderColor="grayBorder"
    _hover={{ bgColor: 'hover' }}
    _first={{ borderTopRadius: 'lg' }}
    _last={{ borderBottomRadius: 'lg' }}
    {...rest}
  >
    {children}
  </Box>
);
